export default "__VITE_ASSET__BVUPsgQx__"